import {clickableGridRows} from "../../kendo-functions";
import {formatGridDateTime, getInitialGridState} from "./downstream-grid-helpers";

const FilterStorageName = "grid-filters";

let defaultFiltersApplied = false;
let _k_grid = null;
let _k_notification = null;

const defaultColumns = [
    {
        field: 'OriginalSubmissionDate',
        title: 'Original Submission Date',
        attributes: {class: ''},
        type: 'date',
        format: '{0: M/d/yyyy}',
        template: function (data) {
            return formatGridDateTime(data.OriginalSubmissionDate);
        },
    }, {
        field: 'ContractType', title: 'Type of Contract', attributes: {class: ''}, type: 'string'
    }, {
        field: 'ProjectName', title: 'Project Name', attributes: {class: ''}, type: 'string'
    }, {
        field: 'ProjectManagerDisplay',
        title: 'Project Manager Name',
        attributes: {class: ''},
        type: 'string',
    }, {
        field: 'SubcontractorVendorName', title: 'Subcontractor Name', attributes: {class: ''}, type: 'string'
    }, {
        field: 'ShortDescription',
        title: 'Short Description',
        attributes: {class: ''},
        type: 'string'
    }, {
        field: 'StatusText',
        title: 'Status',
        width: 100,
        attributes: {class: 'status'},
        template: function (data) {
            let className = '';
            const statusCode = data.Status;

            switch (statusCode) {
                case 1:
                case 4:
                case 7:
                case 9: {
                    className = 'tag--yellow'
                    break;
                }
                case 2:
                case 6: {
                    className = 'tag--blue'
                    break;
                }
                case 3: {
                    className = 'tag--red'
                    break;
                }
                case 5:
                case 8: {
                    className = 'tag--green'
                    break;
                }
            }

            return `<div class="tag tag--small-x ${className}">${data.StatusText}</div>`;
        },
        filterable: true
    }, {
        field: 'StatusDate',
        title: 'Status Date',
        attributes: {class: ''},
        type: 'date', format: '{0: M/d/yyyy}',
        template: function (data) {
            return formatGridDateTime(data.StatusDate);
        }
    }, {
        field: 'SharedServicesComments',
        title: 'Status Comment',
        attributes: {class: ''},
        type: 'string'
    }, {
        field: 'Id', hidden: true, menu: false, attributes: {class: 'requestId'}
    }
]

// Branch is resolved from the page's company menu, not returned by the server, so the server cannot sort or filter by it.
const branchColumn = {
    field: 'branch',
    title: 'Branch',
    attributes: {class: 'status'},
    sortable: false,
    filterable: false,
    template: function (data) {
        return $(`#changeCompany--js a[data-value=${data.Company}]`).text();
    }
}

const initializeRequestGrid = () => {
    let columns = defaultColumns;
    if (isCorporateView()) {
        columns.unshift(branchColumn);
    }
    const {filter, sort} = getInitialGridState(getDefaultFilters());
    _k_grid = $('.js-request-grid').kendoGrid({
        resizable: true, columns: columns, dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true, serverFiltering: true, serverSorting: true, pageSize: 50,
            filter, sort,
            autoSync: true, schema: {
                // Shape of Kendo's DataSourceResult. The aspnetmvc-ajax type only sets the request format, not these.
                data: 'Data', total: 'Total', errors: 'Errors',
                model: {
                    id: 'Id', fields: {
                        Id: { editable: false, type: 'int', hidden: true },
                        OriginalSubmissionDate: { editable: false },
                        Branch: {editable: false, type: 'string'},
                        ContractType: {editable: false, type: 'string'},
                        ProjectName: {editable: false, type: 'string'},
                        ProjectManagerDisplay: {editable: false, type: 'string'},
                        SubcontractorVendorName: {editable: false, type: 'string'},
                        ShortDescription: {editable: false, type: 'string'},
                        SharedServicesComments: { editable: false, type: 'string' },
                        StatusDate: { editable: false },
                        Status: {editable: false, type: 'int'},
                        StatusText: {editable: false, type: 'string'}
                    }
                }
            }, transport: {
                read: {
                    url: `/Operations/DownstreamContract/GetDownstreamContractRequests`, type: 'GET', dataType: 'json'
                }
            }
        }, dataBound: function (arg) {
            clickableGridRows(arg, rowClickedAction);
        }, pageable: {
            alwaysVisible: true,
            pageSizes: [25, 50, 100],
            buttonCount: 20
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: true, columnMenu: true,
        noRecords: {
            template: 'No requests to display.'
        },
        filter(e) {
            setTimeout(() => {
                storeFilter(_k_grid.dataSource.filter(), _k_grid.dataSource.sort());
            }, 250)
        },
        sort(e) {
            setTimeout(() => {
                storeFilter(_k_grid.dataSource.filter(), _k_grid.dataSource.sort());
            }, 250)
        }
    }).data('kendoGrid');

    _k_notification = $('#notification').kendoNotification({
        appendTo: $('.js-request-notification'),
        autoHideAfter: 0,
        hideOnClick: false
    }).data('kendoNotification');
    _k_notification.warning('By clicking "Create New Request Form" above, you are acknowledging that the vendor has been provided a sample copy of the' +
        ' Company\'s standard form and that the vendor has either (1) agreed to the terms or (2) provided requested changes that have been vetted' +
        ' by Legal.  Please do not select a new contract request until this has been completed.');
}

const isCorporateView = () => {
    return $('#changeCompany--js')
        .find('a.menu-settings__link--active')
        .attr('data-value') === '1';
}

const rowClickedAction = (e) => {
    const $currentTarget = $(e.currentTarget);
    const $requestId = $currentTarget.find('.requestId');
    const id = $requestId.text();
    window.location.href = `/Operations/DownstreamContract/RequestForm/${id}`
}

const storeFilter = (filter, sort) => {
    localStorage.removeItem(FilterStorageName);
    const storageObject = {
        filters: filter,
        sort: sort
    }
    localStorage.setItem(FilterStorageName, JSON.stringify(storageObject));
    toggleResetButtonSection();
}
const getDefaultFilters = () => {
    return JSON.parse(localStorage.getItem(FilterStorageName));
}

const removeCachedFilters = () => {
    localStorage.removeItem(FilterStorageName);
}

const resetFilters = () => {
    removeCachedFilters();
    _k_grid.dataSource.filter(null);
    _k_grid.dataSource.sort([]);
    toggleResetButtonSection();
}

const toggleResetButtonSection = () => {
    const filters = getDefaultFilters();

    const $resetSection = $('.js-reset-filter-section');
    $resetSection.toggle(filters != null);
}

const initializeResetFilterButton = () => {
    toggleResetButtonSection();

    const $resetButton = $('.js-reset-filter-button');
    $resetButton.bind('click', resetFilters);
}
export default function () {
    initializeResetFilterButton();
    initializeRequestGrid();
}
